export default __webpack_public_path__ + "static/media/schedule.76783da1.docx";